import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import { Divider, List, ListItem, ListItemText } from '@material-ui/core';
import { useGetSoldOutAggregatedQuery } from 'generated/graphql';
import React, { useMemo } from 'react';
import { format } from 'date-fns';

interface SoldOutTabProps {
	outletID: string;
	startDate: Date | null;
	endDate: Date | null;
	searchQuery: string;
}

export const SoldOutTab: React.FC<SoldOutTabProps> = ({
	outletID,
	startDate,
	endDate,
	searchQuery,
}) => {
	const { data, loading } = useGetSoldOutAggregatedQuery({
		fetchPolicy: 'network-only',
		variables: {
			outletID: outletID,
			startDate: startDate ? format(startDate, 'yyyy-MM-dd') : undefined,
			endDate: endDate ? format(endDate, 'yyyy-MM-dd') : undefined,
		},
	});

	const soldOutItems = data?.getSoldOutAggregated || [];

	const filteredItems = useMemo(() => {
		if (!searchQuery) return soldOutItems;
		const query = searchQuery.toLowerCase();
		return soldOutItems.filter((item: any) => {
			const menuItemName = item.menuItemName || '';
			const docRef = item.docRef || '';
			return menuItemName.toLowerCase().includes(query) ||
				docRef.toLowerCase().includes(query);
		});
	}, [soldOutItems, searchQuery]);

	if (loading) {
		return <Loading />;
	}

	return (
		<List className="core-list">
			{filteredItems.length === 0 ? (
				<EmptyList
					title="No sold out items found"
					subtitle="Sold out items will appear here"
				/>
			) : (
				filteredItems.map((item: any, index: number) => (
					<React.Fragment key={item.ID}>
						<ListItem>
							<ListItemText
								primary={
									<span className="flex-space desc">
										<span className="xsTitle">{item.menuItemName || 'N/A'}</span>
										<span className="desc right-info">
											{item.qtySold?.toFixed(4) || '0.0000'} {item.uomName ? `/${item.uomName}` : ''}
										</span>
									</span>
								}
								secondary={
									<div className="desc" style={{ marginTop: '4px' }}>
										{format(new Date(item.trxDate), 'dd/MM/yyyy')} | {item.docRef || 'N/A'}
									</div>
								}
							/>
						</ListItem>
						{index < filteredItems.length - 1 && <Divider />}
					</React.Fragment>
				))
			)}
		</List>
	);
};

